import { Auth0ContextInterface } from "@auth0/auth0-react";
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import { ViImageData, ViInferenceGetProcessingResponse } from "../models";
import { ViError } from "../models/Errors";

class Client {
  authContext?: Auth0ContextInterface;
  axios?: AxiosInstance;

  init(baseURL: string) {
    this.axios = axios.create({ baseURL });
    return this;
  }

  req({ headers, ...config }: AxiosRequestConfig): Promise<AxiosResponse<any>> {
    if (!this.axios) throw new ViError("ViInferenceClient has not been initialized.");
    try {
      const response = this.axios?.request({ headers, ...config });
      return response;
    } catch (e) {
      throw e;
    }
  }

  async getProcessing(images: ViImageData[]): Promise<ViInferenceGetProcessingResponse> {
    const data: any = {
      imageLevel: images.map((image) => ({
        imageId: image.id,
        imageData: image.data.split(",")[1],
      })),
    };
    const response = await this.req({
      method: "post",
      url: `/claim/full`,
      data,
      params: { return_image_results: true },
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  }
}

export const ViInferenceClient = new Client();
